import { Component, Inject, OnInit, Optional } from '@angular/core';
import { Grid } from '@app/core/components/grid/grid.model';
import { GridOptions } from '@app/core/components/grid/grid.types';
import { ModalService } from '@app/core/services/modal.service';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { AcVoucherTypeGridRow, AcVoucherTypesGet, AcVoucherTypeService } from '@app/services/ac-voucher-type.service';

@Component({
    selector: 'tt-ac-voucher-types',
    templateUrl: './ac-voucher-types.component.html',
    styleUrls: ['./ac-voucher-types.component.css'],
    standalone: false,
})
export class AcVoucherTypesComponent implements OnInit {
    public grid?: GridOptions<AcVoucherTypeGridRow>;

    public page?: AcVoucherTypesGet;

    constructor(
        private modal: ModalService,
        private acVoucherType: AcVoucherTypeService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator,
    ) {
        this.navigator = useNavigatorFor(navigator, this);
    }

    private readGrid() {
        if (!this.grid) {
            this.grid = new Grid<AcVoucherTypeGridRow>().setRememberId('w_acvouchertypes_grid').setLoadDataFunction({ method: AcVoucherTypeService.gridDataTask });
        } else {
            this.grid.gridfunc?.read();
        }
    }

    private async init() {
        this.page = await this.acVoucherType.getAcVoucherTypes();
        this.readGrid();
    }

    public async openSettings(event: MouseEvent) {
        event.preventDefault();

        await this.modal.openStateDialog({ state: 'webpagesettingmenu', params: 'acvouchertypes' }, { width: '90vw', height: '80vh' });
    }

    ngOnInit(): void {
        if (!!this.navigator) {
            this.navigator.setSize?.({ width: '98vw', height: '95vh' });
            this.navigator.setHeading?.('p2_m_acvouchertypes', true);
        }

        this.init();
    }
}
